import { useContext } from "react";
import { cartContext } from "../../App";

export default function DeliveryTime() {

    const { extraData } = useContext(cartContext);

    const now = new Date()
    const hours = Number(now.getHours())
    const min = Number(now.getMinutes()) / 60
    const current = hours + min
    const start = Number(extraData.data.startTime.split(':')[0]) + Number(extraData.data.startTime.split(':')[1])/60
    const end = Number(extraData.data.endTime.split(':')[0]) + Number(extraData.data.endTime.split(':')[1]) / 60
    // const start = 10
    // const end = 12

    if (start === end) {
        return (
            <div style={{display:'flex', flexDirection:'row', alignItems:'baseline'}}>
                <p className='delivery-time' style={{color: 'gray'}}>Unavailable Today </p>
            </div>
        );
    }
    const startTime = Number(extraData.data.startTime.split(':')[0]) > 12 ? Number(extraData.data.startTime.split(':')[0] - 12) + ' PM' : extraData.data.startTime.split(':')[0] + ' AM';


    return (
        <div style={{display:'flex', flexDirection:'row', alignItems:'baseline'}}>
            {
                current > end ?
                    (
                    <>
                        <img src='/icons/fast-delivery.png' alt='thunderbolt-logo' style={{height:'15px', width:'21px', margin:'0 5px 0 0'}}/>
                        <p className='delivery-time' style={{color:'green'}}><span style={{color: 'black'}}>By </span>{startTime}, Tomorrow</p>
                    </>
                    ) :
                    (
                        current < start ?
                            (
                            <>
                                <img src='/icons/fast-delivery.png' alt='thunderbolt-logo' style={{height:'15px', width:'21px', margin:'0 5px 0 0'}}/>
                                    <p className='delivery-time' style={{ color: 'green' }}><span style={{ color: 'black' }}>By </span>{ startTime }, Today</p>
                            </>
                            ) :
                            (
                            <>
                                <p className='delivery-time'>Delivering in </p>
                                <img src='/icons/thunderbolt.png' alt='thunderbolt-logo' style={{height:'15px', width:'18px', margin:'0 0 0 2px'}}/>
                                <p className='delivery-time' style={{color:'green'}}>{extraData.data.deliveryTime} Mins</p>
                            </>
                            )
                    )
            }
        </div>
    );
}